let env = {
  'local': {
    
    // 'rest_url': 'http://localhost:8000',
    // 'rest_url': 'https://arc-api.scieverinc.com',
    'rest_url': 'https://test-api.arc.com.np',
    'redirect_url': 'http://localhost:3001',
    // 'redirect_url': 'https://admin-dev.arc.com.np',  uncomment this 
    // 'redirect_url': 'https://admin-dev.arc.com.np',
    'title': 'local'
  },
};
export const config = () => {
  return env['local'] ;
};